import { Text } from '@react-pdf/renderer'

const PDFParagraph = ({ children, textIndent = 30, lineHeight = 1.8, marginBottom = 20 }) => (
  <Text style={{ lineHeight, marginBottom, textIndent }}>{children}</Text>
)

export default PDFParagraph
